import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Field } from '@atlaskit/form';
import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import { log } from '@atlassian/mpac-utils';
import React, { useState } from 'react';
import ImageDropZone from './ImageDropZone';
import { isImageHavingMinResolution, isImageSizeValid, validateImageFile, validateRequiredImage } from './ImageField.utils';
import ImageUploadBtn from './ImageUploadBtn';
import { jsx as _jsx } from "react/jsx-runtime";
const ImageField = props => {
  const {
    label,
    name,
    imageType,
    url,
    isRequired,
    enableImageDrop,
    customFileName,
    onChange,
    uploadFileHandler
  } = props;
  const [imageUploading, setImageUploading] = useState(false);
  const uploadFile = async (fileToUpload, fieldProps) => {
    setImageUploading(true);
    try {
      const {
        imageUrl,
        assetUrl
      } = await uploadFileHandler(fileToUpload, customFileName);
      const imageFieldUrl = {
        imageUrl,
        assetUrl
      };
      fieldProps.onChange(imageFieldUrl);
      onChange === null || onChange === void 0 ? void 0 : onChange(imageFieldUrl);
    } catch (error) {
      var _error$error;
      fieldProps.onChange({
        validationError: error.message || (error === null || error === void 0 ? void 0 : (_error$error = error.error) === null || _error$error === void 0 ? void 0 : _error$error.statusText)
      });
      log.error("Error uploading image ".concat(name, " of type ").concat(imageType), error);
    } finally {
      setImageUploading(false);
    }
  };
  const validationErrorOnLoad = validateRequiredImage(isRequired !== null && isRequired !== void 0 ? isRequired : false, imageType, url);
  const handleFileChange = fieldProps => async files => {
    if (files && files.length > 0) {
      const selectedFile = files[0];
      const fileName = selectedFile.name;
      const validationError = validateImageFile(fileName);

      // No need to upload the file if it's invalid. Hence early return
      if (validationError) {
        // This is to mark the form dirty, preventing the user from submitting it until the correct file is uploaded.
        fieldProps.onChange({
          validationError
        });
        return;
      }

      // Check file size
      const maxSize = props.maxSizeInMB || 0.293;
      if (!isImageSizeValid(selectedFile, maxSize)) {
        const errorMessage = maxSize < 1 ? "Image size must be less than ".concat((maxSize * 1024).toFixed(0), "KB") : "Image size must be less than ".concat(maxSize, "MB");
        fieldProps.onChange({
          validationError: errorMessage
        });
        return;
      }
      const imageHasValidResolution = await isImageHavingMinResolution(props.minResolution, selectedFile);
      if (!imageHasValidResolution) {
        var _props$minResolution, _props$minResolution2;
        const errorMessage = "Image must be at least ".concat((_props$minResolution = props.minResolution) === null || _props$minResolution === void 0 ? void 0 : _props$minResolution.width, " x ").concat((_props$minResolution2 = props.minResolution) === null || _props$minResolution2 === void 0 ? void 0 : _props$minResolution2.height, "px");
        fieldProps.onChange({
          validationError: errorMessage
        });
        return;
      }
      if (url !== null && url !== void 0 && url.assetUrl) {
        fetchOk(url.assetUrl, {
          method: 'DELETE'
        }).catch(error => {
          log.error("Error deleting image ".concat(name, " of type ").concat(imageType), error);
        });
      }
      await uploadFile(selectedFile, fieldProps);
    }
  };
  const handleFileDelete = fieldProps => () => {
    if (url !== null && url !== void 0 && url.assetUrl) {
      fetchOk(url.assetUrl, {
        method: 'DELETE'
      }).catch(error => {
        log.error("Error deleting image ".concat(name, " of type ").concat(imageType), error);
      });
    }
    fieldProps.onChange({});
    onChange === null || onChange === void 0 ? void 0 : onChange({});
  };
  const ImageUIComponent = enableImageDrop ? ImageDropZone : ImageUploadBtn;
  return /*#__PURE__*/_jsx(Field, {
    name: name,
    label: label,
    defaultValue: _objectSpread(_objectSpread({}, url), {}, {
      validationError: validationErrorOnLoad
    }),
    isRequired: isRequired,
    validate: value => value === null || value === void 0 ? void 0 : value.validationError,
    children: _ref => {
      let {
        fieldProps,
        meta: {
          error
        }
      } = _ref;
      return /*#__PURE__*/_jsx(ImageUIComponent, _objectSpread(_objectSpread({}, props), {}, {
        url: fieldProps.value,
        imageUploading: imageUploading,
        errorMessage: !imageUploading ? error : undefined,
        handleFileChange: handleFileChange(fieldProps),
        handleFileDelete: handleFileDelete(fieldProps),
        enableDeleteImage: props.enableDeleteImage,
        isDisabled: props.isDisabled
      }));
    }
  });
};
export default ImageField;